// Authentication helper functions for Netlify Identity

export function requireLogin() {
  const user = netlifyIdentity.currentUser();
  if (!user) {
    netlifyIdentity.open('login');
    return null;
  }
  return user;
}

export async function getToken() {
  const user = netlifyIdentity.currentUser();
  if (!user) {
    throw new Error('Not signed in');
  }
  return user.jwt();
}

export function isLoggedIn() {
  return !!netlifyIdentity.currentUser();
}

export function getUser() {
  return netlifyIdentity.currentUser();
}

export function logout() {
  netlifyIdentity.logout();
}

export function openLogin() {
  netlifyIdentity.open('login');
}

export function openSignup() {
  netlifyIdentity.open('signup');
}
